/**
 * @file
 * Mitglieder alphabet filter - badges that auto-submit the exposed form.
 * Filter A-F, G-L, M-R, S-Z, Alle for members list.
 *
 * Mutual exclusion: alphabet pills and combined text search cannot be
 * active at the same time. Clicking a letter clears the text input;
 * submitting text resets pills to "Alle".
 */
(() => {
  (function (Drupal, once, $) {
    'use strict';

    function submitForm(form) {
      const $form = $(form);
      const $submitBtn = $form.find('[data-drupal-selector="edit-submit-mitglieder-view"], input[type="submit"], button[type="submit"]').first();

      if ($submitBtn.length) {
        $submitBtn.trigger('click');
      } else {
        form.submit();
      }
    }

    Drupal.behaviors.mitgliederAlphabetFilter = {
      attach: function (context) {
        once('mitgliederAlphabetFilter', '[data-filter-alphabet]', context).forEach(function (container) {
          const badges = container.querySelectorAll('.badge');
          const hiddenInput = container.querySelector('input[type="hidden"]');
          const form = container.closest('form');

          if (!hiddenInput || !form) {
            console.warn('Mitglieder alphabet filter: missing hidden input or form');
            return;
          }

          const nameInput = form.querySelector('[name="combine_name_surname"]');
          let currentValue = hiddenInput.value || 'All';

          function setPressed(badge, isActive) {
            badge.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          }

          function resetBadgesToAll() {
            badges.forEach(function (b) {
              const isAll = b.getAttribute('data-value') === 'All';
              b.classList.toggle('is-active', isAll);
              setPressed(b, isAll);
            });
            hiddenInput.value = 'All';
          }

          badges.forEach(function (badge) {
            const val = badge.getAttribute('data-value');
            const isActive = val === currentValue;
            badge.classList.toggle('is-active', isActive);
            setPressed(badge, isActive);
          });

          badges.forEach(function (badge) {
            badge.addEventListener('click', function (e) {
              e.preventDefault();

              if (badge.classList.contains('is-active')) return;

              badges.forEach(function (b) {
                b.classList.remove('is-active');
                setPressed(b, false);
              });
              badge.classList.add('is-active');
              setPressed(badge, true);

              const value = badge.getAttribute('data-value');
              hiddenInput.value = value;

              // Clear text search when selecting a letter
              if (nameInput) {
                nameInput.value = '';
              }

              submitForm(form);
            });
          });

          // When submitting text search, reset pills to "Alle"
          if (nameInput) {
            const searchBtn = form.querySelector('.mitglieder-name-search button[type="submit"]');

            if (searchBtn) {
              searchBtn.addEventListener('click', function (e) {
                e.preventDefault();
                if (nameInput.value.trim() !== '') {
                  resetBadgesToAll();
                }
                submitForm(form);
              });
            }

            nameInput.addEventListener('keydown', function (e) {
              if (e.key === 'Enter') {
                e.preventDefault();
                if (nameInput.value.trim() !== '') {
                  resetBadgesToAll();
                }
                submitForm(form);
              }
            });
          }
        });
      }
    };
  })(Drupal, once, jQuery);
})();
